import moment from "moment";

export const groupCourses = (courses) => {
  let groupedCourses = [];
  let locations = [];
  courses.forEach((c) => {
    const location = c.activity.location.name;
    if (!locations.includes(location)) {
      locations = [...locations, location];
    }
  });
  locations.forEach((l) => {
    const grouped = courses.filter((c) => c.activity.location.name === l);
    groupedCourses = [...groupedCourses, { location: l, courses: grouped }];
  });
  return groupedCourses;
};

export const getFilteredCourses = (courses, filter) => {
  if (!courses) return [];
  const bookable = () => {
    if (filter.showOnlyBookable)
      return courses.filter(
        (c) => c.canReserve.reserve || c.canReserve.enqueue
      );
    return courses;
  };

  const startDates = () => {
    const courses = bookable();
    if (filter.startDates.length > 0) {
      return courses.filter((course) =>
        filter.startDates.includes(
          moment(course.firstOccasion).format("YYYYWW")
        )
      );
    }
    return courses;
  };

  const locations = () => {
    const courses = startDates();
    if (filter.locations.length > 0) {
      return courses.filter((course) =>
        filter.locations.includes(course.activity.location.name)
      );
    }
    return courses;
  };

  const tags = () => {
    const courses = locations();
    if (filter.tags.length > 0) {
      return courses.filter((course) => {
        let included = false;
        course.activity.tags.forEach((tag) => {
          if (filter.tags.includes(tag)) {
            included = true;
          }
        });
        return included;
      });
    }
    return courses;
  };
  const filtered = tags();
  const sorted = filtered.sort(
    (a, b) => new Date(a.firstOccasion) - new Date(b.firstOccasion)
  );
  const grouped = groupCourses(sorted);
  return grouped;
};

export const getAllFilters = (filter) => {
  let filters = [];
  const filterTypes = Object.keys(filter);
  if (filterTypes.length < 1) return filters;
  filterTypes.forEach((t) => {
    let typeFilter = filter[t];
    if (t === "showOnlyBookable") {
      if (typeFilter) {
        filters = [
          ...filters,
          { value: t, type: t, label: "Visa endast bokningsbara" },
        ];
      }
      return;
    }
    typeFilter.forEach((f) => {
      filters = [...filters, { value: f, type: t, label: f }];
    });
  });
  return filters;
};

export const getWeeksFromCourses = (courses) => {
  if (!courses) return [];
  let returnWeeks = [];
  courses.map((c) => {
    returnWeeks = [...returnWeeks, moment(c.firstOccasion).format("YYYYWW")];
    return returnWeeks;
  });
  return [...new Set(returnWeeks)].sort((a, b) => a - b);
};

export const getTagsFromCourses = (courses) => {
  if (!courses) return [];
  let returnTags = [];
  courses.map((c) => {
    return c.activity.tags.map((t) => {
      if (returnTags.includes(t)) return false;
      return (returnTags = [...returnTags, t]);
    });
  });
  return returnTags.sort();
};

export const getLocationsFromCourses = (courses) => {
  if (!courses) return [];
  let returnLocations = [];
  courses.map((c) => {
    if (returnLocations.includes(c.activity.location.name)) return false;
    return (returnLocations = [...returnLocations, c.activity.location.name]);
  });
  return returnLocations.sort();
};
